"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.array.includes");
var _ordersByMonth = _interopRequireDefault(require("./ordersByMonth"));
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    list: _ordersByMonth.default
  },
  data: function data() {
    return {};
  },
  computed: {
    isList: function isList() {
      var list = ['ordersByMonth'];
      return list.includes(this.$route.name);
    }
  }
};